import type { SxProps, Theme } from '@mui/material';

export const phaseCompleteStatusClassNames = {
  root: 'skill-phase-complete-status',
  icon: 'skill-phase-complete-icon',
  date: 'skill-phase-complete-date',
};

export const phaseCompleteStatusStyles = {
  root: () =>
    ({
      display: 'grid',
      gridTemplateColumns: '30px minmax(0, 1fr)',
      gap: '8px',
      alignItems: 'center',
      color: '#4e9d15',
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: 1.05,
    }) as SxProps<Theme>,

  icon: () =>
    ({
      width: '30px',
      height: '30px',
      display: 'grid',
      placeItems: 'center',
      borderRadius: '999px',
      background: '#56a512',
      color: '#ffffff',
      '& .status-check-icon': {
        width: '23px',
        height: '23px',
      },
    }) as SxProps<Theme>,

  date: () =>
    ({
      display: 'block',
      marginTop: '2px',
      fontSize: '12px',
      fontWeight: 300,
    }) as SxProps<Theme>,
};
